const admissionadvises = {
    feilds: [{
        id: 2,
        name: 'doctorid',
        text: 'Doctor Name',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Doctor',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'departmentbyunit',
        text: 'Department',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Department',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'payer_type',
        text: 'Payer Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Payer Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'bill_value',
        text: 'Bill Value',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Bill Value',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 mb-2 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'nursestationbyunit',
        text: 'Nurse Station',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Nurse Station',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'ward_type',
        text: 'Ward Type',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Ward Type',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     //return (value !== null && value.length > 0);
                //     return true;
                // },
                // message: 'Please Select Specialty'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-3 d-flex pr-1 pl-2'
    }, {
        id: 1,
        name: 'search',
        text: 'IP or UMR No:',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Patient’s Name or IP Number',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     return (value !== null && value.length > 0);
                // },
                // message: 'Please Select Your Appointment Date'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 d-flex pr-1 pl-2'
    },
    {
        id: 2,
        name: 'admission_advises',
        text: 'Date',
        visible: true,
        element: 'daterange',
        required: true,
        input_type: 'date',
        placeholder: 'Select Date',
        icon: 'user',
        rules: [
            // {
            //     test: (value) => {
            //         return (value !== null && value.length > 0);
            //     },
            //     message: 'Please Select  Date'
            // }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-6 d-flex pr-0 float-right'
    }
    ]
}


export { admissionadvises};